import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const fmtDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return d;
  return `${dt.getDate().toString().padStart(2,'0')}/${(dt.getMonth()+1).toString().padStart(2,'0')}/${dt.getFullYear()}`;
};

/**
 * Generate a PDF summary of all pending tasks for one team member.
 * tasks: array of { description, taskType, taskTypeLabel, projectName, deadline, subDescription, overdue }
 */
export const generateTeamMemberTasksPDF = ({ memberName, tasks }) => {
  const doc = new jsPDF({ orientation: 'portrait' });
  const pw = doc.internal.pageSize.getWidth();
  let y = 15;
  const now = new Date();
  const dateStr = `${now.getDate().toString().padStart(2,'0')}/${(now.getMonth()+1).toString().padStart(2,'0')}/${now.getFullYear()}`;

  doc.setFontSize(14); doc.setFont('helvetica', 'bold');
  doc.text('ON GOING TASK', pw / 2, y, { align: 'center' }); y += 7;
  doc.setFontSize(10); doc.setFont('helvetica', 'normal');
  doc.text(`Nama: ${memberName}`, 14, y);
  doc.text(`Tanggal: ${dateStr}`, pw - 14, y, { align: 'right' }); y += 4;

  const overdueCount = tasks.filter(t => t.overdue).length;
  doc.setFontSize(9); doc.setTextColor(90);
  doc.text(`Total: ${tasks.length} pending${overdueCount ? `  ·  ${overdueCount} overdue` : ''}`, 14, y + 4);
  doc.setTextColor(0);
  y += 8;

  if (tasks.length === 0) {
    doc.setFontSize(11);
    doc.text('No pending tasks.', 14, y + 6);
    doc.save(`OngoingTask_${memberName}_${dateStr.replace(/\//g,'-')}.pdf`);
    return;
  }

  const head = [['No', 'Project', 'Type', 'Task', 'Sub-description', 'Deadline']];
  const body = tasks.map((t, i) => [
    i + 1,
    t.projectName || '-',
    t.taskTypeLabel || (t.taskType === 'custom' ? 'Custom' : '-'),
    t.description || '-',
    t.subDescription || '-',
    fmtDate(t.deadline) + (t.overdue ? '  (OVERDUE)' : ''),
  ]);

  autoTable(doc, {
    startY: y,
    head,
    body,
    styles: { fontSize: 8.5, cellPadding: 2, valign: 'middle' },
    headStyles: { fillColor: [51, 65, 85], textColor: 255 },
    columnStyles: {
      0: { cellWidth: 10, halign: 'center' },
      1: { cellWidth: 40 },
      2: { cellWidth: 28 },
      3: { cellWidth: 45 },
      4: { cellWidth: 40 },
      5: { cellWidth: 27, halign: 'center' },
    },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 5) {
        const row = tasks[data.row.index];
        if (row?.overdue) {
          data.cell.styles.textColor = [185, 28, 28];
          data.cell.styles.fontStyle = 'bold';
        }
      }
    },
  });

  doc.save(`OngoingTask_${memberName}_${dateStr.replace(/\//g,'-')}.pdf`);
};
